import React from 'react';
import { reduxForm, Field, change } from 'redux-form';
import { connect } from 'react-redux';
import {
  businessLocations,
  businessCategoriesAll,
  businessOpeningChoices,
} from 'actions';
import { setBusinessInfo } from 'actions/registration';
import * as clevertapRegister from 'clevertap/register';
import styles from './style.css';

const validate = values => {
  const errors = {};
  if (!values.business_opening) {
    errors.business_opening = 'This field is required';
  }
  if (!values.province) {
    errors.province = 'This field is required';
  }
  if (!values.business_category_id) {
    errors.business_category_id = 'This field is required';
  }
  return errors;
};

const inputField = field => {
  return (
    <input
      {...field.input}
      type={field.type || 'text'}
      className={styles['hidden-field']}
    />
  );
};

const renderSelectField = ({ input, meta: { touched, error }, children }) => (
  <div>
    <div>
      <select
        {...input}
        className={`form-control ${styles['input-style']} ${
          touched && error ? styles['input-error'] : ''
        }`}
      >
        {children}
      </select>
      <small className={styles.error}>{touched ? error : ''}</small>
    </div>
  </div>
);

let BusinessInfo = class BusinessInfo extends React.Component {
  constructor(props) {
    super(props);
    const { business } = this.props.data.moka.user;
    const businessId = business.id;
    this.state = {
      businessId,
    };
  }

  componentDidMount() {
    const {
      user: { email, phone },
    } = this.props.data.moka;
    clevertapRegister.clevertapTracker('Registration Business Information', {
      email,
      phone,
    });
    this.props.dispatch(businessCategoriesAll());
    this.props.dispatch(businessLocations());
    this.props.dispatch(businessOpeningChoices());
  }

  handleSubmit = val => {
    this.props.dispatch(
      setBusinessInfo({
        id: this.state.businessId,
        data: { ...val },
      })
    );
  };

  handleCategoryChange = e => {
    const { businessCategoriesAllState } = this.props.data.moka;
    const selectedCategory = businessCategoriesAllState.find(
      category => category.id === parseInt(e.target.value)
    );
    this.props.dispatch(
      change(
        'BusinessInfo',
        'business_type_id',
        selectedCategory.business_type_id
      )
    );
  };

  render() {
    const { handleSubmit, submitting, valid, pristine } = this.props;
    const {
      businessLocationsState,
      businessCategoriesAllState,
      businessOpeningChoices,
    } = this.props.data.moka;
    return (
      <center className={`${styles['mk-register-bg-register']}`}>
        <div
          className={`${
            styles['mk-register-bg-box']
          } col-md-5 col-sm-12 col-xs-12`}
        >
          <div className={`${styles['mk-register-header']} row`}>
            <div className={`col-xs-12 ${styles['title-register']}`}>
              Business Information
            </div>
          </div>
          <div className={`${styles.root} row`}>
            <form onSubmit={handleSubmit(val => this.handleSubmit(val))}>
              <div className="col-xs-12 col-sm-12">
                <div
                  className={`${styles['form-group']} ${
                    styles['margin-bottom-0']
                  }`}
                >
                  <label className={styles['align-left']}>
                    When will your business begin operating?
                  </label>
                  <label htmlFor="businessOpening" className="sr-only">
                    Business Opening
                  </label>
                  <Field
                    name="business_opening"
                    className={`form-control ${styles['input-style']}`}
                    id="businessOpening"
                    component={renderSelectField}
                  >
                    <option key={0} value="">
                      Select Answer
                    </option>
                    {businessOpeningChoices.map(option => (
                      <option value={option.code} key={option.code}>
                        {option.name}
                      </option>
                    ))}
                  </Field>
                  <br />
                </div>
              </div>
              <div className="col-xs-12 col-sm-12">
                <div
                  className={`${styles['form-group']} ${
                    styles['margin-bottom-0']
                  }`}
                >
                  <label className={styles['align-left']}>
                    What type of business is it?
                  </label>
                  <label htmlFor="businessCategory" className="sr-only">
                    Business Category
                  </label>
                  <Field
                    name="business_category_id"
                    className={`form-control ${styles['input-style']}`}
                    id="business_category_id"
                    onChange={this.handleCategoryChange}
                    component={renderSelectField}
                  >
                    <option key={0} value="">
                      Select Business Type
                    </option>
                    {businessCategoriesAllState.map(option => (
                      <option value={option.id} key={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </Field>
                  <Field
                    component={inputField}
                    name="business_type_id"
                    id="business_type_id"
                  />
                  <br />
                </div>
              </div>
              <div className="col-xs-12 col-sm-12">
                <div
                  className={`${styles['form-group']} ${
                    styles['margin-bottom-0']
                  }`}
                >
                  <label className={styles['align-left']}>
                    Where is your business located?
                  </label>
                  <label htmlFor="businessLocation" className="sr-only">
                    Business Location
                  </label>
                  <Field
                    name="province"
                    className={`form-control ${styles['input-style']}`}
                    id="business_location _id"
                    component={renderSelectField}
                  >
                    <option key={0} value="">
                      Select Business Location
                    </option>
                    {businessLocationsState.map(option => (
                      <option value={option.name} key={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </Field>
                  <br />
                </div>
              </div>
              <div className="col-xs-12 col-sm-12">
                <button
                  type="submit"
                  className="btn btn-primary btn-block"
                  disabled={pristine || submitting || !valid}
                >
                  Start Selling
                </button>
              </div>
            </form>
          </div>
        </div>
      </center>
    );
  }
};

BusinessInfo = reduxForm({
  form: 'BusinessInfo',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
})(BusinessInfo);

function select(state) {
  return {
    data: state,
  };
}

export default connect(select)(BusinessInfo);
